module.exports = __webpack_public_path__ + "img/tienda_01_.bb348598.jpg";